import CustomBreadCrumb from '../../../../components/Common/CustomBreadCrumb'
import TrackingLinesCont from '../../../../components/Main/Tracking/Lines/TrackingLinesCont'
import TrackingForm from '../../../../components/Main/Tracking/TrackingForm'
import TrackingList from '../../../../components/Main/Tracking/TrackingList'
import LinkHeader from '../../../../elements/LinkHeader'
import React, { Fragment } from 'react'
import { Button, Card, Col, Popconfirm, Row, Tabs } from 'antd'
import _, { upperFirst } from 'lodash'
import style from '../../../../components/Sales/style.css'
import { strVal } from '../../../../modules/Utils'
import Status from '../../../../elements/Status'
import RefreshButton from '../../../../elements/Buttons/RefreshButton'
import CustomSpin from '../../../../elements/CustomSpin'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'
import CodeIcon from '../../../../elements/CodeIcon'
import Documents from '../../../../components/Common/Documents/DocumentsCont'
import History from '../../../../components/Common/History'

function AddTracking (props) {
  const {
    type,
    submitting,
    updating,
    fetching,
    submit,
    fetch,
    update,
    formRef,
    tracking,
    remove,
    removing,
    submittingSub,
    submitSub,
    isNew,
    subTrackingList,
    fetchingSubTracking,
    fetchSubTracking,
  } = props

  const SubmitButton = () => (
    <FooterButtons
      style={{ marginBottom: 10 }}
      remove={remove}
      removing={removing}
      submit={submit}
      update={update}
      submitting={submitting || updating}
      title={'Tracking'}
      isNew={isNew}
      isEdit={!isNew}
    />
  )

  const isMaster = strVal(tracking, 'type', '') === 'master'

  return (
    <CustomSpin spinning={fetching}>
      <LinkHeader
        title={`${isMaster ? '' : 'Sub'} Tracking Order`}
        type={'Sales'}
        link={{
          pathname: `/clients/orders/${_.get(tracking, 'sales._id', '').replace(
            'sales/',
            '',
          )}/update`,
        }}
        code={_.get(tracking, 'sales.code')}
        name={_.get(tracking, 'sales.title')}
      />
      {!isMaster && (
        <LinkHeader
          title={'Sub Tracking Order'}
          type={'Tracking Order'}
          link={{
            pathname: `/${tracking?.master?._id}/update`,
          }}
          code={_.get(tracking, 'trackingNumber')}
        />
      )}
      <Card>
        <Row className={style.pageHeader}>
          <CustomBreadCrumb
            items={[
              { text: 'Operation' },
              { text: 'Order' },
              { text: 'Tracking Orders', link: '#/tracking' },
              { text: isNew ? 'New Tracking Number' : tracking.trackingNumber, link: '#/tracking' },
            ]}
          />

          {type === 'new' && <h2 className={style.title}>New Technical Drawing</h2>}
          {type === 'edit' && (
            <Fragment>
              <Col span={17}>
                <h3 style={{ marginTop: 20 }}>
                  <CodeIcon code={strVal(tracking, 'trackingNumber')} title={'Tracking Number'}/>
                  <Status value={upperFirst(strVal(tracking, 'status', ''))}/>
                </h3>
              </Col>
              <RefreshButton onClick={fetch}/>
            </Fragment>
          )}
        </Row>
        {isMaster && (
          <Row>
            <Popconfirm title="Are you sure ?" onConfirm={submitSub} okText="Yes" cancelText="No">
              <Button style={{ marginLeft: '10px' }} loading={submittingSub} type="primary">
                Create SubTracking Order
              </Button>
            </Popconfirm>
          </Row>
        )}
      </Card>
      <Card className={style.contentCard}>
        <Tabs defaultActiveKey="form">
          <Tabs.TabPane tab="Details" key="form">
            <Row>
              <SubmitButton/>
            </Row>
            <TrackingForm ref={formRef} {...props} />
          </Tabs.TabPane>

          {isMaster && (
            <Tabs.TabPane disabled={isNew} tab={'Sub'} key="#sub">
              <TrackingList
                {...{
                  list: subTrackingList,
                  fetch: fetchSubTracking,
                  fetching: fetchingSubTracking,
                  hideCompany: true,
                }}
              />
            </Tabs.TabPane>
          )}

          <Tabs.TabPane disabled={isNew} tab={'Lines'} key="#lines">
            <TrackingLinesCont {...{ tracking }} />
          </Tabs.TabPane>

          <Tabs.TabPane disabled={type !== 'edit'} tab="Files" key="files">
            <Documents
              key={tracking._rev}
              editable={true}
              footer={false}
              category={false}
              email={true}
              owner={tracking}
            />
          </Tabs.TabPane>
          <Tabs.TabPane disabled={type !== 'edit'} tab="History" key="history">
            <History owner={tracking} key={tracking._rev} isArray={true}/>
          </Tabs.TabPane>
        </Tabs>
      </Card>
    </CustomSpin>
  )
}

export default AddTracking
